import { createContext } from 'react';

var SupportedLanguages;
(function(SupportedLanguages) {
    SupportedLanguages["JavaScript"] = "javascript";
    SupportedLanguages["JSON"] = "json";
    SupportedLanguages["JSX"] = "jsx";
    SupportedLanguages["Python"] = "python";
    SupportedLanguages["TSX"] = "tsx";
    SupportedLanguages["TypeScript"] = "typescript";
    SupportedLanguages["Bash"] = "bash";
})(SupportedLanguages || (SupportedLanguages = {}));
/**
 * CodeSnippet Context.
 */ const CodeSnippetContext = /*#__PURE__*/ createContext(null);

export { CodeSnippetContext, SupportedLanguages };
//# sourceMappingURL=context.es.js.map
